module.exports = __webpack_public_path__ + "img/no_data.bf791337.svg";